
import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface SearchBarProps {
  isSearchVisible: boolean;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  setIsSearchVisible: (isVisible: boolean) => void;
}

const SearchBar = ({ 
  isSearchVisible, 
  searchQuery, 
  setSearchQuery, 
  setIsSearchVisible 
}: SearchBarProps) => {
  return (
    <div className="w-full max-w-3xl mx-auto mb-6">
      {isSearchVisible ? (
        <div className="relative w-full animate-fade-in">
          <Input
            type="text"
            placeholder="Buscar produtos..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-card/90 backdrop-blur-sm border-border text-foreground pl-10 pr-10 rounded-xl h-12 shadow-md text-base placeholder:text-muted-foreground"
            autoFocus
          />
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <button 
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground p-1"
            onClick={() => setIsSearchVisible(false)}
          >
            ✕
          </button>
        </div>
      ) : (
        <Button
          variant="outline"
          className="bg-card/85 backdrop-blur-sm border-border text-foreground hover:bg-accent rounded-xl px-6 h-12 shadow-md w-full font-medium flex items-center justify-center"
          onClick={() => setIsSearchVisible(true)}
        >
          <Search className="mr-2 h-5 w-5 text-muted-foreground" /> Buscar produtos
        </Button>
      )}
    </div>
  );
};

export default SearchBar;
